module.exports = __webpack_public_path__ + "img/faq-minus.b43a1274.png";